import backlinkApi from './backlinkNewApi';

export const backlinkGap = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getBacklinkGapCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/backlink_gap/',
        method: 'POST',
        body: body
      })
    }),
    getBacklinkGap: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/backlink_gap/',
        method: 'POST',
        body: body
      })
    })
  })
});

export const { useLazyGetBacklinkGapCountQuery, useGetBacklinkGapMutation } =
  backlinkGap;
export default backlinkGap;
